// removed by extract-text-webpack-plugin
module.exports = {"companyInfoBlock":"ZyOJsCp4PlK-LRvatB2qj","infoWr":"_1DHkX31n-MLwhSM8UKqjXc","container":"_1N5zeKJEIOssw4tfJTzHR2","title":"ckpYZMpVuyvt968hX9jpX","anchor":"_2AW_ZnIX81U_NaPkxoDoxa","or":"_2_hWgYwgIP_NHgdNDx3PMW","activeBlock":"_2R0C0rPzkytb5W9dALPuXU","opacityOn":"_25Jk8NC5lMBfzCYmub6ctr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyInfoBlock/CompanyInfoBlock.scss
// module id = 1569
// module chunks = 0